import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const FALLBACK_IMAGE =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDQwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNGM0Y0RjYiLz48L3N2Zz4=';

const ProjectCard = ({ project }) => {
  const { t } = useLanguage();

  const typeLabel = project.type === 'Work' ? t('workProjects') : t('schoolProjects');

  const handleImageError = (e) => {
    e.target.src = FALLBACK_IMAGE;
  };

  return (
    <li>
      <Link to={`/projects/${project.id}`} className="index-row">
        <div className="index-row__thumb">
          <img
            src={project.image}
            alt=""
            loading="lazy"
            decoding="async"
            onError={handleImageError}
          />
        </div>
        <h3 className="index-row__title">{project.title}</h3>
        <p className="index-row__tech">{project.technologies.join(', ')}</p>
        <p className="index-row__type">{typeLabel}</p>
      </Link>
    </li>
  );
};

export default ProjectCard;
